import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../extra/Pagination";
import Button from "../../extra/Button";
import Table from "../../extra/Table";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { ReactComponent as CoinIcon } from "../../../assets/icons/coins.svg";

function UserTransaction(props) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [name, setName] = useState("");
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const { dialogueData, transactionLength, user } = useSelector(
    (state) => state.dialogue,
  );

  const [data, setData] = useState([]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleSelectAll = (event) => {
    const checked = event.target.checked;

    setSelectAllChecked(checked);
    if (checked) {
      setSelectCheckData([...data]);
    } else {
      setSelectCheckData([]);
    }
  };

  const ManageUserData = [
    {
      Header: "Type",
      body: "type",
      Cell: ({ row }) => (
        <span className="text-capitalize    cursorPointer">{row?.type}</span>
      ),
    },
    {
      Header: "Coins Earned",
      body: "coinsEarned",
      Cell: ({ row, index }) => (
        <span className="text-capitalize   cursorPointer text-nowrap">
          {row?.coinsEarned}
        </span>
      ),
    },
  ];

  const handleClose = () => {
    dispatch({
      type: CLOSE_DIALOGUE,
      payload: {
        dialogue: false,
      },
    });

    let dialogueData_ = {
      dialogue: false,
    };
    localStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  useEffect(() => {
    if (dialogueData) {
      setData(dialogueData?.reward?.rewardHistory);
      setName(dialogueData?.user.fullName);
      // console.log(dialogueData?.reward?.totalCoin)
    }
  }, [dialogueData]);

  const totalAdsCoins = dialogueData?.reward?.rewardHistory?.reduce(
    (acc, item) => acc + (item.type === "ADVERTISEMENT" ? item.coinsEarned : 0),
    0,
  );

  const totalLikeCoins = dialogueData?.reward?.rewardHistory?.reduce(
    (acc, item) => acc + (item.type === "VIDEO_LIKE" ? item.coinsEarned : 0),
    0,
  );

  const totalCommentCoins = dialogueData?.reward?.rewardHistory?.reduce(
    (acc, item) => acc + (item.type === "VIDEO_COMMENT" ? item.coinsEarned : 0),
    0,
  );

  const totalDislikeCoins = dialogueData?.reward?.rewardHistory?.reduce(
    (acc, item) => acc + (item.type === "VIDEO_DISLIKE" ? item.coinsEarned : 0),
    0,
  );

  const totalWatchCoins = dialogueData?.reward?.rewardHistory?.reduce(
    (acc, item) => acc + (item.type === "VIDEO_WATCH" ? item.coinsEarned : 0),
    0,
  );

  const totalReferralCoins = dialogueData?.reward?.rewardHistory?.reduce(
    (acc, item) => acc + (item.type === "REFERRAL" ? item.coinsEarned : 0),
    0,
  );

  return (
    <div>
      <div className="user-table real-user mb-3">
        <div className="user-table-top">
          <div style={{ display: "flex", alignItems: "center" }}>
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginBottom: "5px",
                marginTop: "5px",
              }}
            >
              Reward Transaction
            </h5>
            <Button
              btnName={"Back"}
              newClass={"back-btn"}
              onClick={handleClose}
            />
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <p>
              <span style={{ color: "#ff4d67" }}>Username:{" "}</span>
              {name}
            </p>
            <p>
              <span style={{ color: "#ff4d67" }}>Total Watch Time:{" "}</span>
              {dialogueData?.reward?.totalWatchTime || 0} mins
            </p>
          </div>
          <div>
            <span style={{ color: "#ff4d67" }}>
              Total coins earned by User:{" "}
            </span>
            {dialogueData?.reward.totalCoin} <CoinIcon />
          </div>
          <div>
            <span style={{ color: "#ff4d67" }}>
              Total Advertisement coins earned:{" "}
            </span>
            {totalAdsCoins} <CoinIcon />
          </div>
          <div>
            <span style={{ color: "#ff4d67" }}>
              Total Video Like coins earned:{" "}
            </span>
            {totalLikeCoins} <CoinIcon />
          </div>
          <div>
            <span style={{ color: "#ff4d67" }}>
              Total Video Dislike coins earned:{" "}
            </span>
            {totalDislikeCoins} <CoinIcon />
          </div>
          <div>
            <span style={{ color: "#ff4d67" }}>
              Total Video Watch coins earned:{" "}
            </span>
            {totalWatchCoins} <CoinIcon />
          </div>
          <div>
            <span style={{ color: "#ff4d67" }}>
              Total Video Comment coins earned:{" "}
            </span>
            {totalCommentCoins} <CoinIcon />
          </div>
          <div>
            <span style={{ color: "#ff4d67" }}>
              Total Referral coins earned:{" "}
            </span>
            {totalReferralCoins} <CoinIcon />
          </div>
        </div>
        <Table
          data={data}
          mapData={ManageUserData}
          serverPerPage={size}
          serverPage={page}
          handleSelectAll={handleSelectAll}
          selectAllChecked={selectAllChecked}
          type={"server"}
        />
        <Pagination
          type={"server"}
          activePage={page}
          rowsPerPage={size}
          userTotal={transactionLength}
          setPage={setPage}
          handleRowsPerPage={handleRowsPerPage}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
}
export default UserTransaction;
